import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CtaButton} from '@optimaxdev/design-system';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import {AnyAction} from 'redux';

import {UploadPrescriptionForm} from 'components/success/contacts/uploadPrescriptionForm/uploadPrescriptionForm';
import {TYP_CONTACT_LENSES} from 'constants/analytics/events/typ';
import {PRESCRIPTION_STATUS_LABELS} from 'constants/success';
import {ApplicationStoreType} from 'desktop/store';
import {getLabel} from 'libs/success/helpers/helpers';
import {getPopupType} from 'libs/success/prescriptionPopup/prescriptionPopup';
import {FieldType, FileSpeciesType, SUCCESS_PAGE_FIELDS_DEFAULT} from 'types/successPage';

import {getDrawerState, getOrderDetails} from '../../../selectorsV2';
import {changeField, saveOrder} from '../../../store/actions/orderItems/orderItems';
import {
    getSuccessPageItems,
    getUploadedPrescriptionFile,
} from '../../../store/selectors/orderItems/orderItems';
import {getOrderLoading} from '../../../store/selectors/orderStatus/orderStatus';
import {ScreenWrapper} from '../../contacts/screenWrapper/screenWrapper';

/**
 * Upload prescription step
 */
export const UploadPrescription = () => {
    const dispatch = useDispatch();
    const {id, isLoading, item, items, rxMethod, uploadedFile} = useSelector(
        (store: ApplicationStoreType) => ({
            id: getOrderDetails(store).id,
            isLoading: getOrderLoading(store),
            item: getDrawerState(store).item,
            items: getSuccessPageItems(store) as FieldType[],
            rxMethod: getDrawerState(store).rxMethod,
            uploadedFile: getUploadedPrescriptionFile(store),
        }),
        shallowEqual,
    );

    const PRESCRIPTION_STATUS = PRESCRIPTION_STATUS_LABELS[item?.prescription?.send_by || ''];

    const handleUpload = (file: string, name: string, fileType: FileSpeciesType) => {
        dispatch(
            changeField({
                ...SUCCESS_PAGE_FIELDS_DEFAULT,
                fileName: name,
                fileSrc: file,
                fileType,
                orderItemId: String(item?.id),
                type: 'success',
            }),
        );

        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${PRESCRIPTION_STATUS} - ${file ? 'Uploaded Successfully' : 'Upload Again'}`,
        );
    };

    const type = getPopupType(item, '');
    const handleClick = () => {
        const action = saveOrder({
            itemId: String(item?.id),
            items,
            orderId: id,
        });
        sendDesktopAnalyticsEvent(TYP_CONTACT_LENSES, getLabel(rxMethod, true, type));
        dispatch(action as unknown as AnyAction);
    };

    const handleUploadClick = () => {
        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${PRESCRIPTION_STATUS} - Upload prescription - Upload`,
        );
    };

    const Buttons = (
        <CtaButton
            colorName="secondary"
            isDisabled={!uploadedFile}
            isLoading={isLoading}
            onClick={handleClick}
        >
            Confirm & Continue
        </CtaButton>
    );

    return (
        <ScreenWrapper buttons={Buttons}>
            <UploadPrescriptionForm
                onClick={handleUploadClick}
                onUpload={handleUpload}
                uploadedFile={uploadedFile}
            />
        </ScreenWrapper>
    );
};
